import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from '@axios'
import store from '@/store/index'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: () => import('@/views/Dashboard.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/building',
      name: 'building',
      component: () => import('@/views/Building/Building.vue'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Building',
      },
    },
    {
      path: '/device',
      name: 'device',
      component: () => import('@/views/Device/Device.vue'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Device',
      },
    },
    {
      path: '/history',
      name: 'history',
      component: () => import('@/views/History/History.vue'),
      meta: {
        requiresAuth: true,
        pageTitle: 'History',
      },
    },
    {
      path: '/second-page',
      name: 'second-page',
      component: () => import('@/views/SecondPage.vue'),
      meta: {
        pageTitle: 'Second Page',
        breadcrumb: [
          {
            text: 'Second Page',
            active: true,
          },
        ],
      },
    },
    {
      path: '/user',
      name: 'user',
      component: () => import('@/views/user/User.vue'),
      meta: {
        requiresAuth: true,
        pageTitle: 'User',
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        redirectIfLoggedIn: true,
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  axios
    .get('/get-info')
    .then(response => {
      const data = response.data[0]
      if (data.debug === 1) {
        if (to.matched.some(record => record.meta.requiresAuth)) {
          const user = localStorage.getItem('userData')
          if (!user) {
            console.log(1)
            next({
              path: '/login',
            })
          } else {
            console.log(2)
          }
        } if (to.matched.some(record => record.meta.redirectIfLoggedIn)) {
          const user = localStorage.getItem('userData')
          if (user) {
            console.log(3)
            next({
              path: '/',
            })
          } else {
            console.log(4)
            next()
          }
        } store
          .dispatch('auth/bypass')
      } else {
        if (to.matched.some(record => record.meta.requiresAuth)) {
          const user = localStorage.getItem('userData')
          if (!user) {
            console.log(1)
            next({
              path: '/login',
            })
          } else {
            console.log(2)
          }
        } if (to.matched.some(record => record.meta.redirectIfLoggedIn)) {
          const user = localStorage.getItem('userData')
          if (user) {
            console.log(3)
            next({
              path: '/',
            })
          } else {
            console.log(4)
            next()
          }
        }
      }
      return next()
    })
})
// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
